import React from 'react';
import { Card, Elevation, Spinner } from '@blueprintjs/core';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import MainSectionLayout from '../layout/MainSectionLayout';
import { RouteComponentProps } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import {
  ApplicationStore,
  AuthenticationStore,
  DutyTypeStore,
  PharmacyDetailedStore,
  PharmacyStore,
  SecretariatStore,
} from '../../store';
import { SystemStatusStore } from '../../store/SystemStatusStore';
import { SystemStatusSubSystem } from '../../common/enums/SystemStatusSubSystem';
import { Instance } from 'mobx-state-tree';
import { SystemStatus } from '../../store/models/SystemStatus';
import SecretariatCard from './SecretariatCard';
import { Secretariat } from '../../store/models';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

const CardStyle = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

interface HomeProps extends RouteComponentProps<string> {
  PharmacyDetailedStore: Instance<typeof PharmacyDetailedStore>;
  PharmacyStore: Instance<typeof PharmacyStore>;
  DutyTypeStore: Instance<typeof DutyTypeStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  children?: JSX.Element[] | JSX.Element;
}

interface HomeState {
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  transferModuleMode?: string;
  startUp?: Array<Instance<typeof SystemStatus>>;
  collapsed?: boolean;
}

@inject('ApplicationStore')
@inject('SystemStatusStore')
@inject('PharmacyDetailedStore')
@inject('PharmacyStore')
@inject('DutyTypeStore')
@inject('AuthenticationStore')
@inject('SecretariatStore')
@observer
class Home extends React.Component<HomeProps, HomeState> {
  state = {
    collapsed: false,
    transferModuleMode: 'standard',
  } as HomeState;

  _isMounted = false;
  _renderSpinner = true;

  async componentDidMount() {
    this._isMounted = true;
    const criteriaBP: any = {
      subSystem: SystemStatusSubSystem.ACCESS,
    };
    const criteriaStartUp: any = {
      subSystem: SystemStatusSubSystem.STARTUP,
    };
    setTimeout(() => {
      this._renderSpinner = false;
    }, 10000);
    const transferModuleMode = await this.props.ApplicationStore!.getTransferModuleMode();
    const systemStatus = await this.props.SystemStatusStore!.search(criteriaBP);
    const startUp = await this.props.SystemStatusStore!.search(criteriaStartUp);
    // @ts-ignore
    this._isMounted && this.setState({ systemStatus, transferModuleMode });
    // @ts-ignore
    this._isMounted && this.setState({ startUp });
    await this.props.DutyTypeStore.checkListLoaded();
    await this.props.PharmacyStore.checkListLoaded();
    await this.props.SecretariatStore!.checkListLoaded(); //.loadList();
    if (this.props.AuthenticationStore!.isPharmacy && this.props.AuthenticationStore!.pharmacyId !== null) {
      await this.props!.PharmacyDetailedStore!.loadElement(this.props.AuthenticationStore!.pharmacyId);
    }
    console.log('...PRELOADED DEFAULT STORES ' + new Date());
    await this.getSecretariat();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  private getSecretariat = () => {
    let secretariatId = 1;
    if (this.props.AuthenticationStore!.isSuperAdmin) {
      secretariatId = this.props.SecretariatStore!.selectedSecretariatId;
    } else if (
      this.props.AuthenticationStore!.isSecretariat &&
      this.props.AuthenticationStore!.secretariatId !== null
    ) {
      secretariatId = this.props.AuthenticationStore!.secretariatId;
    }
    console.log('this.props.AuthenticationStore!.isSecretariat ' + this.props.AuthenticationStore!.isSecretariat);
    console.log('secretariatId' + secretariatId);
    if (this.props.AuthenticationStore!.isPharmacy && this.props.AuthenticationStore!.pharmacyId !== null) {
      const pharmacy = this.props!.PharmacyDetailedStore!.getById(this.props.AuthenticationStore!.pharmacyId);
      if (pharmacy !== undefined && pharmacy.secretariatId !== undefined) {
        secretariatId = pharmacy.secretariatId;
      }
    }
    const secretariat = this.props.SecretariatStore!.getById(secretariatId);
    return secretariat;
  };

  render() {
    const status =
      this.state.systemStatus && this.state.systemStatus.length != 0 ? this.state.systemStatus![0].status : 'Minimal'; //  .find((elem) => elem.year === 2019 && elem.subSystem === 'Exchange');
    const startUp = this.state.startUp && this.state.startUp.length != 0 ? this.state.startUp![0].status : 'unknown'; //  .find((elem) => elem.year === 2019 && elem.subSystem === 'Exchange');
    const transferModuleMode = this.state.transferModuleMode ? this.state.transferModuleMode : '';
    const titleText =
      transferModuleMode === 'standard'
        ? TLCode.HOME_Title
        : transferModuleMode === 'dedicated'
        ? TLCode.TRANSFER_MODULE_Title
        : TLCode.dummy;

    const secretariat = this.getSecretariat();

    return (
      <MainSectionLayout title={titleText}>
        <Container>
          {status === 'Limited' || status === 'Minimal' ? (
            <>
              <Card className={CardStyle.toString()} interactive={false} elevation={Elevation.TWO}>
                {this._renderSpinner ? (
                  <Spinner />
                ) : (
                  <>
                    <p>Veuillez patienter un instant ou réessayer ultérieurement.</p>
                    {startUp === 'unknown' ? <></> : <p>Redémarrage estimé: {startUp}</p>}
                  </>
                )}
              </Card>
              <br />
              <br />
            </>
          ) : null}
          {transferModuleMode === 'dedicated' && ''}
          {transferModuleMode !== 'dedicated' && <SecretariatCard secretariat={secretariat} />}
        </Container>
      </MainSectionLayout>
    );
  }
}

const HomePage = (props) => {
  return <Home {...props} />;
};

export default HomePage;
